import { subscribeMercureRefresh } from '../../utils/mercureRefresh'
import { Controller } from '@hotwired/stimulus'
import fetchWithHandlingLoginRedirect from '../../modules/utils/fetchWithHandlingLoginRedirect'

const IssueEventType = {
  status_updated: 'issue.status.updated'
}

export default class extends Controller {
  static values = {
    statusSectionUrl: String
  }

  static targets = [
    'statusSection'
  ]

  connect () {
    this.refresh = subscribeMercureRefresh(
      data => data.event === IssueEventType.status_updated,
      context => this.fetchStatusSection(context)
    )
  }

  disconnect () {
    this.refresh.dispose()
    super.disconnect()
  }

  async fetchStatusSection ({ isCurrent }) {
    const response = await fetchWithHandlingLoginRedirect(this.statusSectionUrlValue, { reloadOnNetworkError: false })
    const data = await response.json()
    if (!isCurrent()) return
    this.statusSectionTarget.innerHTML = data.status_section
    document.dispatchEvent(new CustomEvent('HistoryUpdatedEvent'))
  }
}
